// Mainnet Contract Addresses
// BethUtilityToken deployed: Jan 9, 2026
// TX: 0x11341a5ae78b5579b103fe69d90dcfb6e3b5e305bfcb450415afb8aa99d217f5

export const MAINNET_CONTRACTS = {
  BETH_TOKEN: '0x6822824c5349bf005e353ec5dda3fa34595ea811',
  COLLATERAL_VAULT: '0xe86c1f0fd87165cbde68714e6f4cb152e7e5707d',
  CREDIT_LINE: '0x8abfe72db538c6ff99452a910b9bc7a980ef0fdd',
  LIQUIDATION_ENGINE: '0x65e67b63513de0b2bf463c47a2a284254e23fcda',
  TREASURY_MANAGER: '0xc21cd1629a88fe99dbf4cf5d202c04bd493cbf2c',
};

export const MAINNET_CHAIN_ID = '0x1'; // 1 in hex

export const NETWORK_CONFIG = {
  chainId: MAINNET_CHAIN_ID,
  chainName: 'Ethereum Mainnet',
  nativeCurrency: {
    name: 'Ether',
    symbol: 'ETH',
    decimals: 18
  },
  rpcUrls: ['https://eth.llamarpc.com'],
  blockExplorerUrls: ['https://etherscan.io']
};

export const TOKEN_INFO = {
  name: 'Bethereum',
  symbol: 'BETH',
  decimals: 18,
  totalSupply: '1000000000000', // 1 Trillion
};
